import { render, staticRenderFns } from "./PrTableSamplePeaks.vue?vue&type=template&id=4c0fc40e&scoped=true&"
import script from "./PrTableSamplePeaks.vue?vue&type=script&lang=js&"
export * from "./PrTableSamplePeaks.vue?vue&type=script&lang=js&"
import style0 from "./PrTableSamplePeaks.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PrTableSamplePeaks.vue?vue&type=style&index=1&id=4c0fc40e&lang=scss&scoped=true&"
import style2 from "./PrTableSamplePeaks.vue?vue&type=style&index=2&id=4c0fc40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0fc40e",
  null
  
)

export default component.exports